module.exports = __webpack_public_path__ + "static/media/file-music.b492a913.svg";